import { useEffect, useState } from "react";

import TypeCard from "../../../../../../Components/common/DroppedFileList/components/TypeCard/TypeCard";
import { prepareData } from "./threatDetailsUtils";

const ThreatDetailsSidebar = ({
  threatDetailsBySeverity,
  selectedThreatDetail,
  setSelectedThreatDetail,
}) => {
  const [active, setActive] = useState("Sigma");

  const sigma = prepareData(threatDetailsBySeverity, "sigma");
  const yara = prepareData(threatDetailsBySeverity, "Yara");
  const cav = prepareData(threatDetailsBySeverity, "CAV");

  useEffect(() => {
    if (threatDetailsBySeverity?.length === 0) return;

    const sigma = prepareData(threatDetailsBySeverity, "sigma");
    const yara = prepareData(threatDetailsBySeverity, "Yara");
    const cav = prepareData(threatDetailsBySeverity, "CAV");

    if (sigma.length > 0) setSelectedThreatDetail(sigma[0]);
    else if (yara.length > 0) setSelectedThreatDetail(yara[0]);
    else if (cav.length > 0) setSelectedThreatDetail(cav[0]);
  }, [threatDetailsBySeverity]);

  return (
    <div className="thunter-threat-details__sidebar">
      <TypeCard
        value={sigma}
        onClick={setActive}
        active={active}
        selectedFile={selectedThreatDetail}
        setSelectedFile={setSelectedThreatDetail}
        title="Sigma"
      />
      <TypeCard
        value={yara}
        onClick={setActive}
        active={active}
        selectedFile={selectedThreatDetail}
        setSelectedFile={setSelectedThreatDetail}
        title="Yara"
      />
      <TypeCard
        value={cav}
        onClick={setActive}
        active={active}
        selectedFile={selectedThreatDetail}
        setSelectedFile={setSelectedThreatDetail}
        title="CAV"
      />
    </div>
  );
};

export default ThreatDetailsSidebar;
